import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Divider from '@zenbusiness/zui/Divider';
import Skeleton from '@zenbusiness/zui/Skeleton';

import { TrackerCard, ListItemContainer } from '#client/components/OrderTracker/OrderTracker.styles';
import OrderTrackerItem from '#client/components/OrderTracker/OrderTrackerItem';
import { getTitleMessageSuffix } from '#client/components/OrderTracker/utils';
import { HomeSection } from '#client/components/Section';

import { useEnterpriseOrderTracker } from './hooks/useEnterpriseOrderTracker';

function Root({ children, loading }) {
  return (
    <HomeSection title={<FormattedMessage id="dashboard.orderTracker.title" />} titleProps={{ loading }}>
      {children}
    </HomeSection>
  );
}

Root.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
};

function EnterpriseOrderTracker() {
  const { items, loading } = useEnterpriseOrderTracker();

  if (loading) {
    return (
      <Root loading>
        <Skeleton height={300} />
      </Root>
    );
  }

  if (items.length === 0) {
    return null;
  }

  const lastItemIndex = items.length - 1;

  return (
    <Root>
      <TrackerCard>
        {items.map((item, index) => (
          <ListItemContainer key={item.uuid}>
            <OrderTrackerItem
              color={item.color}
              ctaMessageId={`dashboard.orderTracker.orderTaskStatus.${item.status}`}
              hoverTooltipMessageId={item.hoverTooltipMessageId}
              titleMessageId={`dashboard.orderTracker.orderTaskType.${item.type}`}
              titleMessageSuffix={getTitleMessageSuffix(item)}
              type={item.type}
              {...item.linkProps}
            />
            {index !== lastItemIndex && <Divider />}
          </ListItemContainer>
        ))}
      </TrackerCard>
    </Root>
  );
}

export default EnterpriseOrderTracker;
